import { haversine } from '@innovyze/shared-utils/lib/geometry/geometry';
import { geojsonRestictions } from '@Utils/map.utils';

export const calculateRadiusFromBounds = (bounds: number[]): number => {
	let rad = geojsonRestictions.radiusDefault;

	if (bounds.length === 4) {
		const lon1 = bounds[0] + 0.5 * (bounds[2] - bounds[0]);
		const lat1 = bounds[1] + 0.5 * (bounds[3] - bounds[1]);
		rad = haversine(lat1, lon1, bounds[3], bounds[2]);
		rad *= geojsonRestictions.boundMargin;
	}

	return Math.ceil(rad);
};
